import LayoutComponent from "../components/LayoutComponent";
import {Button, Form, Input} from "antd";
import {useState, useEffect} from 'react';
import {useApi} from "../provider/ApiProvider";
import {useHistory} from "react-router-dom";
import CompanySelector from "../components/CompanySelector";
import TextEditor from "../components/TextEditor";
import ImageUpload from "../components/ImageUpload";

import { DatePicker, Space } from 'antd';
import CustomerSelector from "../components/CustomerSelector";
import moment from 'moment';
const { RangePicker } = DatePicker;
const dateFormatList = ['DD.MM.YYYY', 'DD.MM.YYYY'];
const dateFormat = 'DD.MM.YYYY';


// moment.locale('tr_TR');


const {TextArea} = Input;

export default function ActivitySavePage(props){
    const {api, successHandling} = useApi();
    let history = useHistory();

    const [loading, setLoading] = useState(false);
    const [form] = Form.useForm();
    const [imageData, setImageData] = useState(null);
    const [selectedCustomer, setSelectedCustomer] = useState(null);


    useEffect(() => {
        let id = props.match.params.id;
        load(id);
    }, [props.match.params.id])

    async function load(id){
        if(id){
            await api.get('/activityRouter/activity/get/' + id).then(resp => {
                let data = resp.data;
                let date = [moment(data.beginDate), moment(data.endDate)]
                setImageData(data.image);
                let formData = {
                    image: data?.image,
                    CustomerId: data?.CustomerId,
                    CompanyId: data?.CompanyId,
                    PlatformId: data?.PlatformId,
                    title: data?.title,
                    content: data?.content,
                    date: date
                }
                if(data?.CustomerId){
                    setSelectedCustomer(data.Customer);
                }
                form.setFieldsValue(formData);
            })
        }
    }

    async function onChangeImageUpload(value){
        setImageData(value);
    }

    async function save(values){
        if(props.match.params.id){
            let id = props.match.params.id;
            let params = {
                title: values.title,
                content: values.content,
                beginDate: values.date[0],
                endDate: values.date[1],
                CustomerId: values.CustomerId,
                CompanyId: values.CompanyId,
                PlatformId: selectedCustomer?.PlatformId,
                isActive: true,
                isDeleted: false,
            }

            if(imageData){
                let formData = new FormData();
                formData.append('blob',imageData, "new-image");

                await api.upload("/uploadRouter/image/save",formData).then(resp => {
                    if(resp.data.status === true){
                        params.image = resp.data.name;
                        updateData(id, params);
                    }
                })
            }else{
                updateData(id, params);

            }

        }else{
            let params = {
                title: values.title,
                content: values.content,
                beginDate: values.date[0],
                endDate: values.date[1],
                CustomerId: values.CustomerId,
                CompanyId: values.CompanyId,
                PlatformId: selectedCustomer?.PlatformId,
                isActive: true,
                isDeleted: false
            }

            let formData = new FormData();
            formData.append('blob',imageData, "new-image");

            await api.upload("/uploadRouter/image/save",formData).then(resp => {
                console.log(resp, 'resp');
                if(resp.data.status === true){
                    params.image = resp.data.name;

                    storeData(params);

                }
            })

        }
    }

    async function storeData(params){
        await api.post('/activityRouter/activity/store',params).then(resp => {
            //sendNotification(params);
            history.push('/activity');
        })
    }

    async function sendNotification(values){
        setLoading(true);

        await api.post('/notificationRouter/send',{
            customerId: values.CustomerId,
            title: "Yeni Etkinlik",
            message: values.title,

        }).then(resp => {
            successHandling("Bildirim başarıyla gönderildi");
            setLoading(false);

        }).finally(() => {
            setLoading(false);
        })
    }

    async function updateData(id, params){
        console.log(params, 'params');
        await api.put('/activityRouter/activity/update/' + id, params).then(resp => {
            history.push('/activity');
            setLoading(false);
        }).finally(() => {
            setLoading(false);
        })
    }

    return (
        <LayoutComponent links={
            [
                {
                    title: 'Etkinlikler',
                    url: '/activity'
                },
                {
                    title: 'Ekle-Düzenle',
                    url: '/'
                },

            ]}
        >
            <div>
                <ImageUpload value={imageData} name={"image"} onChange={onChangeImageUpload} />

                <Form
                    form={form}
                    name="basic"
                    initialValues={{
                        remember: true,
                    }}
                    labelCol={{
                        span: 4,
                    }}
                    wrapperCol={{
                        span: 20,
                    }}
                    layout="horizontal"
                    onFinish={save}
                    onFinishFailed={() => {}}
                >
                    <Form.Item
                        label="Tarih Aralığı"
                        name="date"
                        rules={[
                            {
                                required: true,
                                message: 'Tarih Aralığı Seçiniz',
                            },
                        ]}
                    >
                        <RangePicker format={dateFormatList} />
                    </Form.Item>
                    <Form.Item
                        label="Müşteri (Kuruluş)"
                        name="CustomerId"
                        rules={[
                            {
                                required: true,
                                message: 'Müşteri Seçiniz',
                            },
                        ]}
                    >
                        <CustomerSelector
                            value={form.getFieldValue('CustomerId')}
                            onChange={(value, found) =>{
                                form.setFieldsValue({ CustomerId: value })
                                setSelectedCustomer(found);
                            }}
                        />
                    </Form.Item>
                    {selectedCustomer && (
                        <Form.Item
                            label="Firma/Şube"
                            name="CompanyId"
                            rules={[
                                {
                                    required: false,

                                },
                            ]}
                        >
                            <CompanySelector
                                value={form.getFieldValue('CompanyId')}
                                onChange={(value) =>form.setFieldsValue({ CompanyId: value })}
                                customerId={selectedCustomer?.id}
                            />
                        </Form.Item>
                    )}

                    <Form.Item
                        label="Başlık"
                        name="title"
                        rules={[
                            {
                                required: true,
                                message: 'Başlık Giriniz',
                            },
                        ]}
                    >
                        <Input />
                    </Form.Item>

                    <Form.Item
                        label="Metin"
                        name="content"
                        rules={[
                            {
                                required: true,
                                message: 'Metin giriniz',
                            },
                        ]}
                    >
                        <TextEditor/>
                    </Form.Item>

                    <div className="form-button">
                        <Button className="submit-btn" loading={loading}  type="primary" htmlType="submit">
                           Kaydet
                        </Button>
                    </div>
                </Form>
            </div>
        </LayoutComponent>
    )
}
